import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { MONTH_PICKER_LAYOUTS } from "./constants";

export const monthPickerDataSchema = z.object({
  value: z.string().optional(),
  min: z.string().optional(),
  max: z.string().optional(),
  placeholder: z.string().optional(),
  locale: z.string().optional(),
  size: z.enum(SIZES).optional(),
  layout: z.enum(MONTH_PICKER_LAYOUTS).optional(),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  arrow: z
    .string()
    .optional()
    .transform((value) =>
      value === undefined ? undefined : value !== "false",
    ),
});

export type MonthPickerDataProps = z.infer<typeof monthPickerDataSchema>;
